import React from "react";
import { TableCell } from "~/table";
import { ImagePreviewActions } from "~/image-preview/ImagePreviewActions";

const IMAGE_URL_PREFIX = "/api/get-image/";

type CertificateActionsProps = {
  certificateImageId: string | null;
  employeeName: string;
  trainingDate: string;
};

export const CertificateActions: React.FC<CertificateActionsProps> = ({
  certificateImageId,
  employeeName,
  trainingDate,
}) => {
  if (!certificateImageId) {
    return <TableCell text="—" />;
  }

  const imageUrl = `${IMAGE_URL_PREFIX}${certificateImageId}`;
  const filename = `${employeeName}-${trainingDate}-certificate`;

  return <ImagePreviewActions imageUrl={imageUrl} filename={filename} />;
};
